export default __webpack_public_path__ + "static/media/2496.ff088621.png";